import * as React from 'react'
// components
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import StaffingData from '../components/sections/Staffing'

const Staffing = () => (
  <>
    <div id='smooth-wrapper'>
      <div id='smooth-content'>
        <div className='podio staffing-wrapper'>
          <StaffingData />
          <Footer />
        </div>
      </div>
    </div>
    <Header />
  </>
)

export default Staffing
